export function sanitizeUTM(value: string | null): string | null {
  if (!value) return null;
  return value.replace(/[^\w\s\-_.]/gi, '');
}
